
import Vue, { VueConstructor } from "vue"
import { EventBus } from "@/plugins/eventBus"

interface Dpae {
  id: number|null,
  error_code?: string,
  error_message?: string,
  pdf_name?: string,
  pdf_receipt?: string,
  reference?: string,
  status: 'pending' | 'processing' | 'urssaf_ack' | 'success' | 'error',
}

export default (Vue as VueConstructor<Vue>).extend({
  name: 'DpaeStatusIcon',
  props: {
    dpaeData: {
      type: Object as () => Dpae | undefined,
      default: undefined
    },
    shadow: { // true to have background color and shadow
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showDpaeMenu: false,
      dpaeMenuActivator: null as HTMLElement | null
    }
  },
  methods: {
    getDpaeColor(status: string) {
      if (status === 'success') {
        return 'success'
      } else if (status === 'error') {
        return 'error'
      } else if (status === 'urssaf_ack') {
        return 'info'
      } else if (status === 'processing') {
        return 'warning'
      } else { // pending
        return 'grey'
      }
    },
    getDpaeIcon(status: string | undefined) {
      if (status === 'success') {
        return 'mdi-file-check'
      } else if (status === 'error') {
        return 'mdi-file-alert'
      } else if (status === 'urssaf_ack') {
        return 'mdi-file-clock'
      } else if (status === 'processing') {
        return 'mdi-file-sync'
      } else {
        return 'mdi-file-clock'
      }
    },
    openDpaeMenu(event: MouseEvent) {
      if (this.dpaeData) {
        this.dpaeMenuActivator = event.currentTarget as HTMLElement
        // Force menu to close first, then reopen
        this.showDpaeMenu = false
        // Use a longer delay to ensure the menu fully closes
        setTimeout(() => {
          this.showDpaeMenu = true
        }, 10)
      }
    },
    downloadDpaePdf(pdfReceipt: string, fileName: string) {
      try {
        // Convert base64 to blob
        const byteCharacters = atob(pdfReceipt);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        
        // Create download link
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        URL.revokeObjectURL(link.href);
      } catch (error) {
        EventBus.$emit('snackbar', { message: this.$vuetify.lang.t('$vuetify.download_pdf_error'), color: 'error' });
      }
    }
  }
})
